import { render } from "./LibraryCreate.vue?vue&type=template&id=5d27d8ca"
import script from "./LibraryCreate.vue?vue&type=script&lang=js"
export * from "./LibraryCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__